export class CodeBlockModel {
    name = 'New Block';
    hovered = false;
    description = '';
    content = '';
    language = 'javascript'
}